// extracted by mini-css-extract-plugin
export var articleCard = "article-card-module--article-card--016cu";
export var articleCard__mainContent = "article-card-module--article-card__main-content--AelGF";
export var articleCard__image = "article-card-module--article-card__image--LJIxx";
export var articleCard__title = "article-card-module--article-card__title--OaULK";
export var articleCard__link = "article-card-module--article-card__link--I9sGN";
export var articleCard__desc = "article-card-module--article-card__desc--70IPs";
export var articleCard__tag = "article-card-module--article-card__tag--4IaO6";
export var articleCard__note = "article-card-module--article-card__note--0GJaN";